/**
 * Margem no prazo de entrega — hnow theme
 *
 * O app de frete (Kokfy) devolve o prazo como texto pronto, e ele aparece em
 * três lugares: página de produto (escrita pelo próprio app), página de
 * carrinho e carrinho lateral (escritas pelos snippets calculo-frete-*).
 * Este script reescreve só esse texto, somando a margem ao fim do prazo:
 *
 *   "4 dias úteis"      -> "4-7 dias úteis"
 *   "1 dia útil"        -> "1-4 dias úteis"
 *   "3 a 5 dias úteis"  -> "3-8 dias úteis"   (a margem vai no maior prazo)
 *
 * O valor e o cálculo do frete não mudam, nem o prazo que o checkout mostra —
 * o checkout é do app, não passa pelo tema.
 *
 * Margem: settings.frete_prazo_margem, lida de data-frete-margem no <html>.
 */
(function () {
  'use strict';

  var margem = parseInt(document.documentElement.getAttribute('data-frete-margem'), 10);
  if (isNaN(margem) || margem <= 0) return;

  // Só "a"/"até" contam como separador de faixa. O texto que este script
  // escreve usa hífen, então nunca volta a casar com o padrão e a margem não
  // é somada duas vezes.
  var PADRAO = /^(?:até\s+)?(\d+)(?:\s+(?:a|até)\s+(\d+))?\s+(dias?)(\s+úte?is|\s+útil)?$/i;

  // Nó de texto -> valor já escrito, para saber se o app trocou o texto depois.
  var aplicados = new WeakMap();

  function converter(texto) {
    var m = texto.trim().match(PADRAO);
    if (!m) return null;
    var inicio = parseInt(m[1], 10);
    var fim = (m[2] ? parseInt(m[2], 10) : inicio) + margem;
    var uteis = m[4] ? ' úteis' : '';
    return inicio + '-' + fim + ' dias' + uteis;
  }

  function tratarNo(no) {
    var atual = no.nodeValue;
    if (!atual || !atual.trim()) return;
    if (aplicados.get(no) === atual) return;
    var novo = converter(atual);
    if (novo === null) return;
    // Preserva espaços em volta, que o template do app às vezes deixa.
    var saida = atual.replace(atual.trim(), novo);
    aplicados.set(no, saida);
    no.nodeValue = saida;
  }

  function tratarItem(li) {
    var walker = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null);
    var no;
    while ((no = walker.nextNode())) tratarNo(no);
  }

  // Mesmo critério do frete-limit.js: uma lista é de frete quando seus itens
  // têm .ship-name ou .ship-price. Isso vale para os três lugares.
  function varrer(raiz) {
    if (!raiz || raiz.nodeType !== 1 || !raiz.querySelectorAll) return;
    var itens = raiz.querySelectorAll('li');
    if (raiz.tagName === 'LI') tratarItem(raiz);
    for (var i = 0; i < itens.length; i++) {
      var li = itens[i];
      if (li.querySelector('.ship-name, .ship-price')) tratarItem(li);
    }
  }

  function iniciar() {
    varrer(document.body);
    new MutationObserver(function (mutacoes) {
      for (var i = 0; i < mutacoes.length; i++) {
        var m = mutacoes[i];
        if (m.type === 'characterData') {
          var li = m.target.parentElement && m.target.parentElement.closest('li');
          if (li && li.querySelector('.ship-name, .ship-price')) tratarNo(m.target);
          continue;
        }
        for (var k = 0; k < m.addedNodes.length; k++) {
          var n = m.addedNodes[k];
          if (n.nodeType === 1) {
            varrer(n);
            var dono = n.closest && n.closest('li');
            if (dono && dono.querySelector('.ship-name, .ship-price')) tratarItem(dono);
          } else if (n.nodeType === 3) {
            var pai = n.parentElement && n.parentElement.closest('li');
            if (pai && pai.querySelector('.ship-name, .ship-price')) tratarNo(n);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();
